export enum IseeLevel {
  PRIMARY_LEVEL = "Primary Level",
  LOWER_LEVEL = "Lower Level",
  MIDDLE_LEVEL = "Middle Level",
  UPPER_LEVEL = "Upper Level",
}
